import { ContentType, EncryptionType, GroupKeyRequest, GroupKeyResponse } from '@streamr/trackerless-network';
import { toUserId, toUserIdRaw } from '@streamr/utils';
import { MessageID as StreamMessageID } from './MessageID';
import { MessageRef as StreamMessageRef } from './MessageRef';
import { StreamMessage, StreamMessageType } from './StreamMessage';
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class StreamMessageTranslator {
    static toProtobuf(msg) {
        const messageId = {
            timestamp: msg.getTimestamp(),
            sequenceNumber: msg.getSequenceNumber(),
            streamId: msg.getStreamId(),
            streamPartition: msg.getStreamPartition(),
            publisherId: toUserIdRaw(msg.getPublisherId()),
            messageChainId: msg.getMsgChainId()
        };
        let previousMessageRef = undefined;
        if (msg.prevMsgRef) {
            previousMessageRef = {
                timestamp: msg.prevMsgRef.timestamp,
                sequenceNumber: msg.prevMsgRef.sequenceNumber
            };
        }
        let body;
        if (msg.messageType === StreamMessageType.MESSAGE) {
            let newGroupKey = undefined;
            if (msg.newGroupKey) {
                newGroupKey = {
                    id: msg.newGroupKey.id,
                    data: msg.newGroupKey.data
                };
            }
            body = {
                oneofKind: 'contentMessage',
                contentMessage: {
                    content: msg.content,
                    contentType: msg.contentType,
                    encryptionType: msg.encryptionType,
                    groupKeyId: msg.groupKeyId ?? undefined,
                    newGroupKey
                }
            };
        }
        else if (msg.messageType === StreamMessageType.GROUP_KEY_REQUEST) {
            body = {
                oneofKind: 'groupKeyRequest',
                groupKeyRequest: GroupKeyRequest.fromBinary(msg.content)
            };
        }
        else if (msg.messageType === StreamMessageType.GROUP_KEY_RESPONSE) {
            body = {
                oneofKind: 'groupKeyResponse',
                groupKeyResponse: GroupKeyResponse.fromBinary(msg.content)
            };
        }
        else {
            throw new Error('invalid message type');
        }
        const translated = {
            messageId,
            previousMessageRef,
            signature: msg.signature,
            signatureType: msg.signatureType,
            body
        };
        return translated;
    }
    static toClientProtocol(msg) {
        let messageType;
        let content;
        let contentType = ContentType.BINARY;
        let encryptionType = EncryptionType.NONE;
        let newGroupKey = undefined;
        let groupKeyId = undefined;
        if (msg.body.oneofKind === 'contentMessage') {
            messageType = StreamMessageType.MESSAGE;
            content = msg.body.contentMessage.content;
            contentType = msg.body.contentMessage.contentType;
            encryptionType = msg.body.contentMessage.encryptionType;
            newGroupKey = msg.body.contentMessage.newGroupKey;
            groupKeyId = msg.body.contentMessage.groupKeyId;
        }
        else if (msg.body.oneofKind === 'groupKeyRequest') {
            messageType = StreamMessageType.GROUP_KEY_REQUEST;
            try {
                content = GroupKeyRequest.toBinary(msg.body.groupKeyRequest);
            }
            catch (err) {
                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                throw new Error(`invalid group key request: ${err}`);
            }
        }
        else if (msg.body.oneofKind === 'groupKeyResponse') {
            messageType = StreamMessageType.GROUP_KEY_RESPONSE;
            try {
                content = GroupKeyResponse.toBinary(msg.body.groupKeyResponse);
            }
            catch (err) {
                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                throw new Error(`invalid group key response: ${err}`);
            }
        }
        else {
            throw new Error('invalid message type');
        }
        const messageId = new StreamMessageID(msg.messageId.streamId, msg.messageId.streamPartition, Number(msg.messageId.timestamp), msg.messageId.sequenceNumber, toUserId(msg.messageId.publisherId), msg.messageId.messageChainId);
        let prevMsgRef = undefined;
        if (msg.previousMessageRef) {
            prevMsgRef = new StreamMessageRef(Number(msg.previousMessageRef.timestamp), msg.previousMessageRef.sequenceNumber);
        }
        const translated = new StreamMessage({
            messageId,
            prevMsgRef,
            messageType,
            content,
            contentType,
            signature: msg.signature,
            signatureType: msg.signatureType,
            encryptionType,
            groupKeyId,
            newGroupKey
        });
        return translated;
    }
}
